/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SessionCacheToggleRequest,
} from '../models/index';
import {
    SessionCacheToggleRequestFromJSON,
    SessionCacheToggleRequestToJSON,
} from '../models/index';

export interface ClearCache1Request {
    sessionId?: string;
}

export interface DisableSessionCacheRequest {
    sessionId?: string;
}

export interface EnableSessionCacheRequest {
    sessionId?: string;
}

export interface GetCacheHealth1Request {
    sessionId?: string;
}

export interface GetCacheStatsRequest {
    sessionId?: string;
}

export interface GetSessionCacheConfigRequest {
    sessionId?: string;
}

export interface PerformHealthCheckRequest {
    sessionId?: string;
}

export interface ToggleSessionCacheRequest {
    sessionCacheToggleRequest: SessionCacheToggleRequest;
    sessionId?: string;
}

export interface UpdateSessionCacheConfigRequest {
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

/**
 * CacheManagementApi - interface
 * 
 * @export
 * @interface CacheManagementApiInterface
 */
export interface CacheManagementApiInterface {
    /**
     * Clears all data from the session cache
     * @summary Clear cache
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApiInterface
     */
    clearCache1Raw(requestParameters: ClearCache1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Clears all data from the session cache
     * Clear cache
     */
    clearCache1(requestParameters: ClearCache1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Disables session caching
     * @summary Disable session cache
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApiInterface
     */
    disableSessionCacheRaw(requestParameters: DisableSessionCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Disables session caching
     * Disable session cache
     */
    disableSessionCache(requestParameters: DisableSessionCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Enables session caching
     * @summary Enable session cache
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApiInterface
     */
    enableSessionCacheRaw(requestParameters: EnableSessionCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Enables session caching
     * Enable session cache
     */
    enableSessionCache(requestParameters: EnableSessionCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves the health status of the session cache
     * @summary Get cache health
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApiInterface
     */
    getCacheHealth1Raw(requestParameters: GetCacheHealth1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves the health status of the session cache
     * Get cache health
     */
    getCacheHealth1(requestParameters: GetCacheHealth1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves statistics about the session cache
     * @summary Get cache statistics
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApiInterface
     */
    getCacheStatsRaw(requestParameters: GetCacheStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves statistics about the session cache
     * Get cache statistics
     */
    getCacheStats(requestParameters: GetCacheStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves the current session cache configuration
     * @summary Get cache configuration
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApiInterface
     */
    getSessionCacheConfigRaw(requestParameters: GetSessionCacheConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves the current session cache configuration
     * Get cache configuration
     */
    getSessionCacheConfig(requestParameters: GetSessionCacheConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Performs a health check on the session cache
     * @summary Perform cache health check
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApiInterface
     */
    performHealthCheckRaw(requestParameters: PerformHealthCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Performs a health check on the session cache
     * Perform cache health check
     */
    performHealthCheck(requestParameters: PerformHealthCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Toggles session caching on/off
     * @summary Toggle session cache
     * @param {SessionCacheToggleRequest} sessionCacheToggleRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApiInterface
     */
    toggleSessionCacheRaw(requestParameters: ToggleSessionCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Toggles session caching on/off
     * Toggle session cache
     */
    toggleSessionCache(requestParameters: ToggleSessionCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Updates the session cache configuration
     * @summary Update cache configuration
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheManagementApiInterface
     */
    updateSessionCacheConfigRaw(requestParameters: UpdateSessionCacheConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Updates the session cache configuration
     * Update cache configuration
     */
    updateSessionCacheConfig(requestParameters: UpdateSessionCacheConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class CacheManagementApi extends runtime.BaseAPI implements CacheManagementApiInterface {

    /**
     * Clears all data from the session cache
     * Clear cache
     */
    async clearCache1Raw(requestParameters: ClearCache1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cache/clear`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Clears all data from the session cache
     * Clear cache
     */
    async clearCache1(requestParameters: ClearCache1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.clearCache1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Disables session caching
     * Disable session cache
     */
    async disableSessionCacheRaw(requestParameters: DisableSessionCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cache/config/disable`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Disables session caching
     * Disable session cache
     */
    async disableSessionCache(requestParameters: DisableSessionCacheRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.disableSessionCacheRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enables session caching
     * Enable session cache
     */
    async enableSessionCacheRaw(requestParameters: EnableSessionCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cache/config/enable`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Enables session caching
     * Enable session cache
     */
    async enableSessionCache(requestParameters: EnableSessionCacheRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.enableSessionCacheRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the health status of the session cache
     * Get cache health
     */
    async getCacheHealth1Raw(requestParameters: GetCacheHealth1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cache/health`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves the health status of the session cache
     * Get cache health
     */
    async getCacheHealth1(requestParameters: GetCacheHealth1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCacheHealth1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves statistics about the session cache
     * Get cache statistics
     */
    async getCacheStatsRaw(requestParameters: GetCacheStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cache/stats`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves statistics about the session cache
     * Get cache statistics
     */
    async getCacheStats(requestParameters: GetCacheStatsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCacheStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the current session cache configuration
     * Get cache configuration
     */
    async getSessionCacheConfigRaw(requestParameters: GetSessionCacheConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cache/config`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves the current session cache configuration
     * Get cache configuration
     */
    async getSessionCacheConfig(requestParameters: GetSessionCacheConfigRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getSessionCacheConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Performs a health check on the session cache
     * Perform cache health check
     */
    async performHealthCheckRaw(requestParameters: PerformHealthCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cache/health/check`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Performs a health check on the session cache
     * Perform cache health check
     */
    async performHealthCheck(requestParameters: PerformHealthCheckRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.performHealthCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Toggles session caching on/off
     * Toggle session cache
     */
    async toggleSessionCacheRaw(requestParameters: ToggleSessionCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionCacheToggleRequest'] == null) {
            throw new runtime.RequiredError(
                'sessionCacheToggleRequest',
                'Required parameter "sessionCacheToggleRequest" was null or undefined when calling toggleSessionCache().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cache/config/toggle`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SessionCacheToggleRequestToJSON(requestParameters['sessionCacheToggleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Toggles session caching on/off
     * Toggle session cache
     */
    async toggleSessionCache(requestParameters: ToggleSessionCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.toggleSessionCacheRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the session cache configuration
     * Update cache configuration
     */
    async updateSessionCacheConfigRaw(requestParameters: UpdateSessionCacheConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateSessionCacheConfig().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cache/config/update`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Updates the session cache configuration
     * Update cache configuration
     */
    async updateSessionCacheConfig(requestParameters: UpdateSessionCacheConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateSessionCacheConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
